import ApiUrl from "../../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = async (setValues)=>{
    let res = await fetch(ApiUrl.Admin_Pointsrate, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    if(res.status > 400 && res.status < 410){
        localStorage.removeItem('user-info');
        document.location.replace('/');
    }
    res = await res.json();
    if(res.success){
        setValues(res.response.rate);
    }
    else{
        alert(res.response);
    }
}

const Post = async (toast,body,setValues)=>{
    const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_RIGHT});
    let res = await fetch(ApiUrl.Admin_Pointsrate, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    });
    if(res.status > 400 && res.status < 410){
        localStorage.removeItem('user-info');
        document.location.replace('/');
    }
    res = await res.json();
    if(res.success){
        setTimeout(() => {
          toast.update(toastid, { render: "Saved", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_RIGHT });
        }, 500);
        Get(setValues);
    }
    else{
        setTimeout(() => {
          toast.update(toastid, { render: res.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_RIGHT });
        }, 500);
    }
}


export default {Get,Post}